import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import { Fragment } from 'react/jsx-runtime';
import type { ConfigFilter } from '../../../_configs/types';
import RHFTextField from '../../../components/hook-form/rhf-text-field/component';
import Iconify from '../../../components/iconify/component';
import { useRootContainerContext } from '../../../context/root-container';
import { useSettingsContext } from '../../../context/settings';
import { type UseCarSearchReturn } from '../../../hooks/use-car-search/types';
import { useResponsive } from '../../../hooks/use-responsive';
import useLocales from '../../../hooks/useLocales';
import checkUndefined from '../../../utils/tools/checkUndefined';
import checkUndefinedNullOrEmpty from '../../../utils/tools/checkUndefinedNullOrEmpty';
import uniqueArray from '../../../utils/tools/uniqueArray';
import { type FilterMap } from './maps/filterMap';
import getFilterElement from './utils/getFilterElement';

type FahrzeugSucheFilterSideBarProps = {
    filterElements: FilterMap;
    loading: boolean;
    results: UseCarSearchReturn['results'];
};

export function FahrzeugSucheFilterSideBar(props: FahrzeugSucheFilterSideBarProps) {
    const { filterElements, loading, results } = props;
    const settings = useSettingsContext();
    const rootContainer = useRootContainerContext();
    const { translate } = useLocales();
    const xs = useResponsive(rootContainer, 'down', 'sm');

    const sidebarFilters = (
        !settings?.fahrzeugsuche?.filter?.sidebar?.includes('tags')
            ? uniqueArray<ConfigFilter>(['tags', ...(settings?.fahrzeugsuche?.filter?.sidebar || [])])
            : uniqueArray<ConfigFilter>(settings?.fahrzeugsuche?.filter?.sidebar)
    )?.filter((key) => {
        const filterElement = filterElements?.[key];
        return checkUndefined(settings?.fahrzeugsuche?.forcedFilter?.[filterElement?.filterKey]) && (key !== 'tags' || !checkUndefinedNullOrEmpty(results?.facets?.[filterElement?.facetKey]));
    });

    return (
        <Stack data-testid="FahrzeugSucheFilterSideBar_Container" spacing={2} justifyContent="space-between">
            <Stack gap={2}>
                <RHFTextField
                    ariaLabel={translate('common:filter.searchText')}
                    data-testid="freier_text"
                    disabled={settings?.general?.mockup}
                    fullWidth
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Iconify icon="eva:search-fill" />
                            </InputAdornment>
                        ),
                    }}
                    name="freier_text"
                    placeholder={translate('common:filter.volltext')}
                />
            </Stack>

            <Divider />

            <Stack gap={2}>
                {uniqueArray(sidebarFilters?.map((key) => (
                    // Fragment for key prop to silence React error
                    <Fragment key={`Sidebar_Filter_Fragment_${key}`}>
                        {getFilterElement(key, results, settings, translate, xs, loading)}
                    </Fragment>
                )))}
            </Stack>
        </Stack>
    );
}
